// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EncuestasPage_containerFilaBusqueda__Yp5Q8 {
  display: flex;

  align-items: center;
  padding: 0px;
  width: 100%;
  margin: 0px;
  justify-content: space-between;
  flex-wrap: wrap;
}

.EncuestasPage_titulo__Pf6gU {
  font-weight: bold;
  font-size: 1.2rem;
  color: var(--text-color);
  margin-bottom: 20px;
  justify-self: flex-start;
  text-align: left;
  width: 100%;
  display: flex;
  margin-left: 10px;
}
.EncuestasPage_divInformacion__16DrZ {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  flex: 1 1;
  width: 100%;
}
.EncuestasPage_labelSinEncuestas__f1x6u {
  font-size: 1.5rem;
  width: 100%;
  font-weight: bold;
  padding-top: 100px;
  padding-bottom: 100px;
}

.EncuestasPage_divTodoEnUnaFila__9EQ9o {
  display: flex;
  flex-direction: row;
  margin-left: 0px;
  margin-left: 10px;
}

.EncuestasPage_divCampos__ckaiz {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-content: flex-start;
  justify-content: flex-start;
  justify-items: flex-start;
  margin-left: 0px;
}

.EncuestasPage_divCamposItem__Q00\\+T {
  display: flex;
  flex-direction: row;
  margin-left: 0px;
  margin-top: 10px;
  text-wrap: wrap;
  word-wrap: break-word;
}

.EncuestasPage_atributo__ei27M {
  font-size: 0.8rem;
  font-weight: bold;
  text-wrap: wrap;
  text-align: left;
  color: var(--text-color-claro);
}

.EncuestasPage_valor__6YDMj {
  font-size: 0.8rem;
  color: var(--text-color-claro-2);
  margin-left: 5px;
  text-align: left;
  word-wrap: break-word;
  max-width: 100%;
}

.EncuestasPage_divBotonera__f9Ja3 {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  margin-top: 20px;
  flex-wrap: wrap;
  gap: 5px;
}

.EncuestasPage_circleImage__C-TnS {
  width: 100%; /* Ajusta el tamaño según tus necesidades */
  height: 100px; /* Asegúrate de que el alto y el ancho sean iguales para un círculo perfecto */
  border-radius: 8px; /* Esto crea el círculo */
  object-fit: cover; /* Asegura que la imagen cubra completamente el espacio sin deformarse */
  margin-right: 0px;
  border-width: 1px;
  border-style: solid;
  margin-bottom: 10px;
}
/* EncuestasPage.module.css */

.EncuestasPage_containerGrillaUsuarios__P8f4H {
  display: flex;
  flex-direction: column;
  align-content: center;
  align-items: center;
  justify-content: flex-start;
  height: 100%;
  width: 100%;
}

/* EncuestasPage.module.css */
.EncuestasPage_containerGrillaUsuarios__P8f4H {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 10px; /* Espacio entre los cuadros */
}

.EncuestasPage_containerUsuario__SApxl {
  width: 100%;
  border-radius: 15px;
  border-color: gray;
  border-width: 1px;
  border-style: solid;
  padding: 10px;
  margin: 10px; /* Agrega un poco de margen entre los botones */
}

/* EncuestasPage.module.css */
.EncuestasPage_containerGrillaUsuarios__P8f4H {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 10px; /* Espacio entre los cuadros */
}

.EncuestasPage_containerUsuario__SApxl {
  flex: 1 1 100%;
  max-width: 100%;
  margin: 10px 0;
}

@media (min-width: 640px) {
  .EncuestasPage_containerUsuario__SApxl {
    /* Asume que esta es la clase de tus BotonCardComponent */
    flex: 1 1 45%; /* Ajusta la base y la capacidad de crecimiento/reducción para que cada botón tome aproximadamente un tercio del espacio */
    max-width: 45%; /* Asegura que los botones no sean más anchos que el 30% */
    margin: 10px; /* Agrega un poco de margen entre los botones */
  }
}
/* EncuestasPage.module.css */
.EncuestasPage_containerGrillaUsuarios__P8f4H {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 10px; /* Espacio entre los cuadros */
}

.EncuestasPage_containerUsuario__SApxl {
  flex: 1 1 100%;
  max-width: 100%;
  margin: 10px 0;
}

@media (min-width: 1024px) {
  .EncuestasPage_containerUsuario__SApxl {
    /* Asume que esta es la clase de tus BotonCardComponent */
    flex: 1 1 30%; /* Ajusta la base y la capacidad de crecimiento/reducción para que cada botón tome aproximadamente un tercio del espacio */
    max-width: 28%; /* Asegura que los botones no sean más anchos que el 30% */
  }
}

.EncuestasPage_containerUsuario__SApxl {
  width: 100%;
  border-radius: 15px;
  border-color: gray;
  border-width: 1px;
  border-style: solid;
  padding: 10px;
  margin-top: 10px; /* Agrega un poco de margen entre los botones */
}

@media (min-width: 640px) {
  .EncuestasPage_containerFilaBusqueda__Yp5Q8 {
    flex-wrap: nowrap;
  }

  .EncuestasPage_divBotonera__f9Ja3 {
    width: 70%;
    margin-left: 15px;
  }
}

@media (min-width: 1024px) {
  /* Ajusta este valor según tus necesidades */
  .EncuestasPage_containerGrillaUsuarios__P8f4H {
    flex-direction: row; /* Cambio en la dirección de flex para alinear los elementos en fila */
    flex-wrap: wrap; /* Permite que los elementos se envuelvan en la siguiente línea si no hay espacio */
    justify-content: flex-start; /* Distribuye el espacio alrededor de los elementos */
  }

  .EncuestasPage_containerUsuario__SApxl {
    flex: 1 1 45%;
    max-width: 45%;
  }

  .EncuestasPage_circleImage__C-TnS {
    width: 30%; /* Ajusta el tamaño según tus necesidades */
    height: auto; /* Asegúrate de que el alto y el ancho sean iguales para un círculo perfecto */
    border-radius: 50%; /* Esto crea el círculo */
    object-fit: cover; /* Asegura que la imagen cubra completamente el espacio sin deformarse */

    border-width: 1px;
    border-style: solid;
  }
}

@media (min-width: 1200px) {
  .EncuestasPage_containerUsuario__SApxl {
    flex: 1 1 30%;
    max-width: 30%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/principal/panel/encuestas/EncuestasPage.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;;EAEb,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,WAAW;EACX,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,wBAAwB;EACxB,mBAAmB;EACnB,wBAAwB;EACxB,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,SAAO;EACP,WAAW;AACb;AACA;EACE,iBAAiB;EACjB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;EACzB,2BAA2B;EAC3B,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,WAAW,EAAE,2CAA2C;EACxD,aAAa,EAAE,8EAA8E;EAC7F,kBAAkB,EAAE,yBAAyB;EAC7C,iBAAiB,EAAE,wEAAwE;EAC3F,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;AACrB;AACA,6BAA6B;;AAE7B;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,mBAAmB;EACnB,2BAA2B;EAC3B,YAAY;EACZ,WAAW;AACb;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,SAAS,EAAE,8BAA8B;AAC3C;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,YAAY,EAAE,+CAA+C;AAC/D;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,SAAS,EAAE,8BAA8B;AAC3C;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE;IACE,yDAAyD;IACzD,aAAa,EAAE,0HAA0H;IACzI,cAAc,EAAE,0DAA0D;IAC1E,YAAY,EAAE,+CAA+C;EAC/D;AACF;AACA,6BAA6B;AAC7B;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,SAAS,EAAE,8BAA8B;AAC3C;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE;IACE,yDAAyD;IACzD,aAAa,EAAE,0HAA0H;IACzI,cAAc,EAAE,0DAA0D;EAC5E;AACF;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,gBAAgB,EAAE,+CAA+C;AACnE;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,UAAU;IACV,iBAAiB;EACnB;AACF;;AAEA;EACE,4CAA4C;EAC5C;IACE,mBAAmB,EAAE,sEAAsE;IAC3F,eAAe,EAAE,mFAAmF;IACpG,2BAA2B,EAAE,qDAAqD;EACpF;;EAEA;IACE,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,UAAU,EAAE,2CAA2C;IACvD,YAAY,EAAE,8EAA8E;IAC5F,kBAAkB,EAAE,yBAAyB;IAC7C,iBAAiB,EAAE,wEAAwE;;IAE3F,iBAAiB;IACjB,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,aAAa;IACb,cAAc;EAChB;AACF","sourcesContent":[".containerFilaBusqueda {\n  display: flex;\n\n  align-items: center;\n  padding: 0px;\n  width: 100%;\n  margin: 0px;\n  justify-content: space-between;\n  flex-wrap: wrap;\n}\n\n.titulo {\n  font-weight: bold;\n  font-size: 1.2rem;\n  color: var(--text-color);\n  margin-bottom: 20px;\n  justify-self: flex-start;\n  text-align: left;\n  width: 100%;\n  display: flex;\n  margin-left: 10px;\n}\n.divInformacion {\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n  flex: 1;\n  width: 100%;\n}\n.labelSinEncuestas {\n  font-size: 1.5rem;\n  width: 100%;\n  font-weight: bold;\n  padding-top: 100px;\n  padding-bottom: 100px;\n}\n\n.divTodoEnUnaFila {\n  display: flex;\n  flex-direction: row;\n  margin-left: 0px;\n  margin-left: 10px;\n}\n\n.divCampos {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  align-content: flex-start;\n  justify-content: flex-start;\n  justify-items: flex-start;\n  margin-left: 0px;\n}\n\n.divCamposItem {\n  display: flex;\n  flex-direction: row;\n  margin-left: 0px;\n  margin-top: 10px;\n  text-wrap: wrap;\n  word-wrap: break-word;\n}\n\n.atributo {\n  font-size: 0.8rem;\n  font-weight: bold;\n  text-wrap: wrap;\n  text-align: left;\n  color: var(--text-color-claro);\n}\n\n.valor {\n  font-size: 0.8rem;\n  color: var(--text-color-claro-2);\n  margin-left: 5px;\n  text-align: left;\n  word-wrap: break-word;\n  max-width: 100%;\n}\n\n.divBotonera {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  margin-top: 20px;\n  flex-wrap: wrap;\n  gap: 5px;\n}\n\n.circleImage {\n  width: 100%; /* Ajusta el tamaño según tus necesidades */\n  height: 100px; /* Asegúrate de que el alto y el ancho sean iguales para un círculo perfecto */\n  border-radius: 8px; /* Esto crea el círculo */\n  object-fit: cover; /* Asegura que la imagen cubra completamente el espacio sin deformarse */\n  margin-right: 0px;\n  border-width: 1px;\n  border-style: solid;\n  margin-bottom: 10px;\n}\n/* EncuestasPage.module.css */\n\n.containerGrillaUsuarios {\n  display: flex;\n  flex-direction: column;\n  align-content: center;\n  align-items: center;\n  justify-content: flex-start;\n  height: 100%;\n  width: 100%;\n}\n\n/* EncuestasPage.module.css */\n.containerGrillaUsuarios {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  gap: 10px; /* Espacio entre los cuadros */\n}\n\n.containerUsuario {\n  width: 100%;\n  border-radius: 15px;\n  border-color: gray;\n  border-width: 1px;\n  border-style: solid;\n  padding: 10px;\n  margin: 10px; /* Agrega un poco de margen entre los botones */\n}\n\n/* EncuestasPage.module.css */\n.containerGrillaUsuarios {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  gap: 10px; /* Espacio entre los cuadros */\n}\n\n.containerUsuario {\n  flex: 1 1 100%;\n  max-width: 100%;\n  margin: 10px 0;\n}\n\n@media (min-width: 640px) {\n  .containerUsuario {\n    /* Asume que esta es la clase de tus BotonCardComponent */\n    flex: 1 1 45%; /* Ajusta la base y la capacidad de crecimiento/reducción para que cada botón tome aproximadamente un tercio del espacio */\n    max-width: 45%; /* Asegura que los botones no sean más anchos que el 30% */\n    margin: 10px; /* Agrega un poco de margen entre los botones */\n  }\n}\n/* EncuestasPage.module.css */\n.containerGrillaUsuarios {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  gap: 10px; /* Espacio entre los cuadros */\n}\n\n.containerUsuario {\n  flex: 1 1 100%;\n  max-width: 100%;\n  margin: 10px 0;\n}\n\n@media (min-width: 1024px) {\n  .containerUsuario {\n    /* Asume que esta es la clase de tus BotonCardComponent */\n    flex: 1 1 30%; /* Ajusta la base y la capacidad de crecimiento/reducción para que cada botón tome aproximadamente un tercio del espacio */\n    max-width: 28%; /* Asegura que los botones no sean más anchos que el 30% */\n  }\n}\n\n.containerUsuario {\n  width: 100%;\n  border-radius: 15px;\n  border-color: gray;\n  border-width: 1px;\n  border-style: solid;\n  padding: 10px;\n  margin-top: 10px; /* Agrega un poco de margen entre los botones */\n}\n\n@media (min-width: 640px) {\n  .containerFilaBusqueda {\n    flex-wrap: nowrap;\n  }\n\n  .divBotonera {\n    width: 70%;\n    margin-left: 15px;\n  }\n}\n\n@media (min-width: 1024px) {\n  /* Ajusta este valor según tus necesidades */\n  .containerGrillaUsuarios {\n    flex-direction: row; /* Cambio en la dirección de flex para alinear los elementos en fila */\n    flex-wrap: wrap; /* Permite que los elementos se envuelvan en la siguiente línea si no hay espacio */\n    justify-content: flex-start; /* Distribuye el espacio alrededor de los elementos */\n  }\n\n  .containerUsuario {\n    flex: 1 1 45%;\n    max-width: 45%;\n  }\n\n  .circleImage {\n    width: 30%; /* Ajusta el tamaño según tus necesidades */\n    height: auto; /* Asegúrate de que el alto y el ancho sean iguales para un círculo perfecto */\n    border-radius: 50%; /* Esto crea el círculo */\n    object-fit: cover; /* Asegura que la imagen cubra completamente el espacio sin deformarse */\n\n    border-width: 1px;\n    border-style: solid;\n  }\n}\n\n@media (min-width: 1200px) {\n  .containerUsuario {\n    flex: 1 1 30%;\n    max-width: 30%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"containerFilaBusqueda": `EncuestasPage_containerFilaBusqueda__Yp5Q8`,
	"titulo": `EncuestasPage_titulo__Pf6gU`,
	"divInformacion": `EncuestasPage_divInformacion__16DrZ`,
	"labelSinEncuestas": `EncuestasPage_labelSinEncuestas__f1x6u`,
	"divTodoEnUnaFila": `EncuestasPage_divTodoEnUnaFila__9EQ9o`,
	"divCampos": `EncuestasPage_divCampos__ckaiz`,
	"divCamposItem": `EncuestasPage_divCamposItem__Q00+T`,
	"atributo": `EncuestasPage_atributo__ei27M`,
	"valor": `EncuestasPage_valor__6YDMj`,
	"divBotonera": `EncuestasPage_divBotonera__f9Ja3`,
	"circleImage": `EncuestasPage_circleImage__C-TnS`,
	"containerGrillaUsuarios": `EncuestasPage_containerGrillaUsuarios__P8f4H`,
	"containerUsuario": `EncuestasPage_containerUsuario__SApxl`
};
export default ___CSS_LOADER_EXPORT___;
